import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments';
import { Observable } from 'rxjs';

export interface VerifiedDeceasedPayload {
  decedentPoid: string;
}

export interface VerifiedDeceasedResponse {
  isDeceased: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class VerifiedDeceasedService {
  constructor(private http: HttpClient) {}

  verifiedDeceased(
    verifiedDeceasedPayload: VerifiedDeceasedPayload,
  ): Observable<VerifiedDeceasedResponse> {
    return this.http.post<VerifiedDeceasedResponse>(
      `secure/verified-deceased`,
      verifiedDeceasedPayload,
    );
  }
}
